export default __webpack_public_path__ + "static/media/tecsupport.700bea8f.jpg";